import React, { useState, useCallback, useEffect } from 'react';
import { getAllTakeaways } from '../../../services/OrderService';
import TakeawayHistoryList from '../../components/OrderHistory/TakeawayHistoryList';

const TakeawayHistory = () => {
    const [takeawayData, setTakeawayData] = useState({
        data: [],
        current_page: 1,
        total_pages: 1
    });
    const [pageItems, setPageItems] = useState(10);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isInitialized, setIsInitialized] = useState(false);

    const getTakeaways = useCallback((page = 1, itemsPerPage = pageItems) => {
        getAllTakeaways(page, itemsPerPage, fromDate, toDate)
            .then(response => {
                if (response) {
                    // Extract data and pagination info from the response
                    const data = Array.isArray(response.data) ? response.data : [];
                    const totalPages = response.total_pages || 1;
                    const currentPage = response.current_page || page;
                    
                    console.log('Takeaway pagination:', { currentPage, totalPages });

                    setTakeawayData({
                        data: data,
                        current_page: currentPage,
                        total_pages: totalPages
                    });
                } else {
                    // Handle empty or invalid response
                    setTakeawayData({
                        data: [],
                        current_page: 1,
                        total_pages: 1
                    });
                }
                setPageItems(itemsPerPage);
            })
            .catch(error => {
                console.error("Error fetching takeaways:", error);
                // Set empty data on error
                setTakeawayData({
                    data: [],
                    current_page: 1,
                    total_pages: 1
                });
            });
    }, [fromDate, toDate, pageItems]);

    const handlePageChange = (page) => {
        getTakeaways(page, pageItems);
    };

    const handlePageItemsChange = (items) => {
        setPageItems(items);
        getTakeaways(1, items);
    };

    const handleDateFilter = (from, to) => {
        // Update state first
        setFromDate(from);
        setToDate(to);
        
        // Then fetch data with the updated filters
        // Use the parameters directly rather than state variables
        // since state updates are asynchronous
        getAllTakeaways(1, pageItems, from, to)
            .then(response => {
                if (response) {
                    // Extract data and pagination info from the response
                    const data = Array.isArray(response.data) ? response.data : [];
                    const totalPages = response.total_pages || 1;
                    
                    console.log('Date filter pagination:', { currentPage: 1, totalPages });

                    setTakeawayData({
                        data: data,
                        current_page: 1,
                        total_pages: totalPages
                    });
                } else {
                    setTakeawayData({
                        data: [],
                        current_page: 1,
                        total_pages: 1
                    });
                }
            })
            .catch(error => {
                console.error("Error filtering takeaways:", error);
                setTakeawayData({
                    data: [],
                    current_page: 1,
                    total_pages: 1
                });
            });
    };
    
    // Initialize component with data on first render
    useEffect(() => {
        if (!isInitialized) {
            getTakeaways(1, pageItems);
            setIsInitialized(true);
        }
    }, [getTakeaways, isInitialized, pageItems]);

    return (
        <TakeawayHistoryList 
            takeawayList={takeawayData.data}
            getTakeaways={getTakeaways}
            pagination={{
                currentPage: takeawayData.current_page,
                totalPages: takeawayData.total_pages
            }}
            pageItems={pageItems}
            onPageChange={handlePageChange}
            onPageItemsChange={handlePageItemsChange}
            onDateFilter={handleDateFilter}
        />
    );
}

export default TakeawayHistory;